import React from 'react';
import './DecorativeFilmsPage.css';

const DecorativeFilmsPage = () => (
  <main className="decorative-films-main">
    <section className="decorative-films-top">
      <div className="decorative-films-top-content">
        <h1>Decorative Films</h1>
      </div>
    </section>

    <section className="decorative-films-hero">
      <div className="decorative-films-hero-content">
        <p className="decorative-films-intro">
          Derma Protec's Decorative Films are premium retrofit solutions engineered to elevate the performance and longevity of existing glazing. Our films combine exceptional clarity and flexibility for seamless integration with all standard glass types. Each film carries a durable hard-coat layer to resist scratches during installation and routine maintenance, ensuring an immaculate finish over time.
        </p>
      </div>
    </section>

    <div className="decorative-films-img-center">
      <img src="https://i.postimg.cc/J4fnzyJq/decorative-film-derma.png" alt="Decorative Films Derma Protec" className="decorative-films-content-img" />
    </div>

    <section className="decorative-films-features">
      <h2>Key Features:</h2>
      <ul className="decorative-films-features-list">
        <li><strong>Ultra-Clear Polyester Base</strong> – Maintains visual transparency while adding structural reinforcement to protect against shattering.</li>
        <li><strong>High-Strength Adhesive</strong> – Bonds securely to glass surfaces, holding broken fragments in place on impact.</li>
        <li><strong>Advanced Solar Control</strong> – Incorporated metals, inorganic pigments, and infrared-rejecting compounds work together to reduce glare.</li>
        <li><strong>Scratch-Resistant Hard Coat</strong> – Preserves film integrity and optical performance through daily cleaning and environmental exposure.</li>
      </ul>
      <p>Perfect for both commercial and residential settings, our decorative line can transform any glass surface into a design statement without sacrificing natural light or view.</p>
    </section>

    <div className="decorative-films-img-center">
      <img src="https://i.postimg.cc/YqG07N40/decorative-film-2-derma.png" alt="Decorative Films Derma Protec Example 2" className="decorative-films-content-img" />
    </div>

    <section className="decorative-films-highlights">
      <h2>Decorative Series Highlights:</h2>
      <ul className="decorative-films-highlights-list">
        <li><strong>Frosted & Etched Finishes</strong> – Provide privacy in offices, bathrooms, and conference rooms while diffusing harsh light for a softer interior ambiance.</li>
        <li><strong>Patterned & Textured Designs</strong> – From geometric lattices to organic motifs, our patterns add visual interest and brand identity to storefronts, partitions, and feature walls.</li>
        <li><strong>Gradient & One-Way Films</strong> – Create dynamic light transitions or daytime privacy effects, ideal for lobbies, reception areas, and display windows.</li>
        <li><strong>Custom Graphics & Logos</strong> – Fully bespoke printing options allow for high-resolution images, corporate branding, or wayfinding elements directly on the film.</li>
      </ul>
    </section>

    <section className="decorative-films-benefits">
      <h2>Benefits of Decorative Films:</h2>
      <ul className="decorative-films-benefits-list">
        <li><strong>Cost-Effective Glass Upgrade</strong> – Delivers etched-glass aesthetics at a fraction of the price, with the flexibility to remove or replace designs as needs evolve.</li>
        <li><strong>UV & Glare Control</strong> – Many decorative variants block up to 100% of UV rays and reduce glare, protecting interiors and enhancing occupant comfort.</li>
        <li><strong>Easy Maintenance & Durability</strong> – Hard-coated, scratch-resistant surfaces stand up to regular cleaning without peeling or discoloration.</li>
        <li><strong>Rapid Installation</strong> – Applied to existing glass with minimal disruption—no structural changes required.</li>
      </ul>
      <p>Whether you're reinforcing safety, controlling solar gain, or adding designer flair, Derma Protec's comprehensive film portfolio offers a tailored solution for every architectural challenge. Contact us to explore samples, request a custom design, or find a certified installer in your area.</p>
    </section>
  </main>
);

export default DecorativeFilmsPage; 